import { action } from 'sky-engine/api/index'

import { FEEDBACK } from '@/api/apiModules'

export function createFeedback(data) {
  return action(FEEDBACK, 'create', data)
}

export function updateFeedback(data) {
  return action(FEEDBACK, 'edit', data)
}

export function getFeedbackDetail(data) {
  return action(FEEDBACK, 'detail', data)
}

/**
 * 获取工具
 * @returns
 */
export function getToolName(params) {
  return action(FEEDBACK, 'getToolName', params)
}
